import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

/**
 * Export array of data objects to Excel (.xlsx) or CSV (.csv) file
 * @param {Array<Object>} data Array of objects to export
 * @param {string} fileName Base file name without extension
 * @param {'excel'|'csv'} [format='excel'] Format to export
 * @param {Array<{key: string, label: string}>} [columns=null] Optional column mapping
 */
export const exportDataToFile = (
  data,
  fileName = "Export_Data",
  format = "excel",
  columns = null
) => {
  try {
    if (!data || !data.length) {
      alert("No data available to export.");
      return;
    }

    let formattedData = data;
    if (columns && columns.length > 0) {
      formattedData = data.map((row) => {
        const obj = {};
        columns.forEach((col) => {
          const key = col.key || col.field || col.label;
          const label = col.label || col.key || col.field;
          obj[label] = row[key] !== undefined && row[key] !== null ? row[key] : "";
        });
        return obj;
      });
    }

    const cleanTitle = (fileName || "Export").replace(/[^a-zA-Z0-9_\- ]/g, "").slice(0, 31) || "Sheet1";
    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, cleanTitle);

    if (format === "csv") {
      const csv = XLSX.utils.sheet_to_csv(ws);
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      saveAs(blob, `${fileName || "export"}.csv`);
    } else {
      const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      saveAs(blob, `${fileName || "export"}.xlsx`);
    }
  } catch (err) {
    console.error("Export error:", err);
    alert("Failed to export file: " + (err?.message || "Unknown error"));
  }
};

export default exportDataToFile;
